/* eslint-disable no-param-reassign */
import produce from 'immer';

import { REASON_CODE_DICTIONARY } from './constants';
/**
 *
 * @param {array} reasons  An array of reason codes or an error code
 * @param {object} defaultErrors The default error values
 */
export const parseReasonCodes = (reasons, defaultErrors) => {
  const {
    accountNumber,
    additionalEscrow,
    additionalPrincipal,
    bannerError,
    lateCharge,
    nameOnAccount,
    nsfFees,
    numberOfPayments,
    routingNumber,
    scheduledDate,
    sourcesBannerError,
  } = produce(defaultErrors, (draft) => {
    reasons.forEach((reasonCode) => {
      if (REASON_CODE_DICTIONARY[reasonCode]) {
        const { key, message } = REASON_CODE_DICTIONARY[reasonCode];
        if (key === 'bannerError') {
          draft.bannerError = message;
        } else if (key === 'sourcesBannerError') {
          draft.sourcesBannerError = message;
        } else {
          draft[key] = message;
        }
      }
    });
  });
  return {
    otp: {
      amount: {
        additionalEscrow,
        additionalPrincipal,
        lateCharge,
        nsfFees,
        numberOfPayments,
      },
      bannerError,
      scheduledDate,
    },
    sources: {
      account: {
        accountNumber,
        nameOnAccount,
        routingNumber,
      },
      bannerError: sourcesBannerError,
    },
  };
};

// check if reasons array has any full error reason codes, order of arrays does not matter
export const checkFullErrorReasonCodes = (arr1, arr2) => arr1.some((val) => arr2.includes(val));

export const generateCancelOtpModalProps = ({
  dispatchCancelOtp,
  dispatchSetIsModalOpen,
  ...restProps
}) => ({
  handleCloseModal: () => dispatchSetIsModalOpen({ key: 'cancel', value: false }),
  handleOnPress: dispatchCancelOtp,
  label: 'Confirm',
  // eslint-disable-next-line max-len
  text: 'Are you sure you want to cancel your payment request of <b>{{amount}}</b> for <b>{{date}}</b>?',
  title: 'Cancel Payment',
  ...restProps,
});
